import logo from './logo.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

function App() {
  const navigate = useNavigate();

  const handleButtonClick = (buttonName) => {
    if (buttonName === "Button1") {
      navigate('/checkout-customer');
    } else if (buttonName === "Button2") {
      navigate('/fix-pseq');
    }else if (buttonName === "ButtonAbsenWajah"){
      navigate('/absen-wajah');
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h2>BISAN SFA Management</h2>

        <div className="button-row">
          <button onClick={() => handleButtonClick("Button1")}>Check Out Customer</button>
          <button onClick={() => handleButtonClick("Button2")}>Fix PSEQ Keliru</button>
          <button onClick={() => handleButtonClick("ButtonAbsenWajah")}>Absen Wajah</button>
        </div>
      </header>
    </div>
  );
}

export default App;
